const actionTypes = {

    INITIALIZE: 'INITIALIZE',
    COIN_API_SUCCESS: 'COIN_API_SUCCESS',
    COIN_API_ERROR: 'COIN_API_ERROR',

    INITIALIZE_COIN:'INITIALIZE_COIN',
    EXCHANGE_SUCCESS: 'EXCHANGE_SUCCESS',
    EXCHANGE_ERROR: 'EXCHANGE_ERROR',

    SELECT_COIN:'SELECT_COIN',
    SELECT_SUCCESS: 'SELECT_SUCCESS',
    SELECT_ERROR: 'SELECT_ERROR',

    SELECT_CURRENCY:'SELECT_CURRENCY',
    SELECT_CURRENCY_SUCCESS:'SELECT_CURRENCY_SUCCESS',
    SELECT_CURRENCY_ERROR:'SELECT_CURRENCY_ERROR',

    SEARCH_COIN:'SEARCH_COIN',
    SEARCH_COIN_SUCCESS:'SEARCH_COIN_SUCCESS',
}

export default actionTypes